const es = {
    DOES_NOT_CONTAIN: 'No contiene',
    CONTAINS: 'Contiene',
    RANGE: 'Rango de',
    EQUALS: 'Igual',
    ENDS_WITH: 'Termina con',
    STARTS_WITH: 'Comienza con',
    APPLY: 'Aplicar',
    NUMERIC: 'Numérico',
    TO: 'a'
};
export { es };
